import React from 'react';
import cls from '@utils/css-select';
import styles from './styles.scss'
import { useTranslation } from 'hooks/use-translation';

const cx = cls(styles)

function EmptyTable() {
	const { transData: { noTransYet } } = useTranslation('profile')
	return (
		<div className={cx('empty-table')}>
			<div className={cx('img-wrap')}>
				<img src='https://web-data.zmlearn.com/image/rd5fWKowMYhDcBVQ3E9YBY/empty.png' alt='empty-table' loading='lazy' />
			</div>
			<p>{noTransYet}</p>
		</div>
	)
}

export default EmptyTable
